var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import useWindowWidth from "syf-component-library/ui/customHooks/useWindowWidth";
// Necessary for nice rendering of text and annotation layers; otherwise it renders random blank spaces and overflowing text
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { numericBreaks } from "syf-component-library/const/mediaQueries";
import { Loader } from "./subcomponents";
import Pagination from "../Pagination";
pdfjs.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@".concat(pdfjs.version, "/build/pdf.worker.min.mjs");
var DOCUMENT_MAX_WIDTH = 1038; // Value from Figma
var NUMBER_OF_BUTTONS = 4;
var DocumentPage = function (_a) {
    var filePath = _a.filePath;
    var _b = useWindowWidth(), width = _b.width, isLessThanTablet = _b.isLessThanTablet;
    var _c = useState(1), numberOfPages = _c[0], setNumberOfPages = _c[1];
    var _d = useState(1), firstNumberOfButtons = _d[0], setFirstNumberOfButtons = _d[1];
    var _e = useState(1), currentPage = _e[0], setCurrentPage = _e[1];
    var scrollToTop = function () {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window.scrollTo) === null || _a === void 0 ? void 0 : _a.call(window, { top: 0, behavior: "instant" });
    };
    var goNext = function () {
        if (currentPage < numberOfPages) {
            var nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            if (nextPage > firstNumberOfButtons + NUMBER_OF_BUTTONS - 1) {
                setFirstNumberOfButtons(firstNumberOfButtons + 1);
            }
            scrollToTop();
        }
    };
    var goBack = function () {
        if (currentPage > 1) {
            var prevPage = currentPage - 1;
            setCurrentPage(prevPage);
            if (prevPage < firstNumberOfButtons) {
                setFirstNumberOfButtons(firstNumberOfButtons - 1);
            }
            scrollToTop();
        }
    };
    var goToPage = function (page) {
        setCurrentPage(page);
        scrollToTop();
    };
    var onDocumentLoadSuccess = function (numPages) {
        setNumberOfPages(numPages);
    };
    // Needed to be responsive when resizing
    var pageWidth = isLessThanTablet ? width * 0.9 : width * 0.65;
    return (_jsxs(Document, __assign({ loading: _jsx(Loader, {}), file: filePath, 
        // eslint-disable-next-line no-console
        onLoadError: function (error) { return console.error(error); }, onLoadSuccess: function (pdf) {
            // eslint-disable-next-line no-underscore-dangle
            onDocumentLoadSuccess(pdf._pdfInfo.numPages);
            scrollToTop();
        }, className: "pdfstyle" }, { children: [_jsx(Page, { pageNumber: currentPage, width: width > numericBreaks.huge ? DOCUMENT_MAX_WIDTH : pageWidth }), _jsx(Pagination, { currentPage: currentPage, firstNumberOfButtons: firstNumberOfButtons, numberOfPages: numberOfPages, numberOfButtons: NUMBER_OF_BUTTONS, goNext: goNext, goBack: goBack, goToPage: goToPage })] })));
};
export default DocumentPage;
